import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';
import React from 'react';
import styled from 'styled-components';

const HairMap = styled.div<{
  color?: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
  pointer-events: none;
  z-index: -1;

  img {
    min-width: 100px;
  }
`;

export interface Props {
  data: ISimejiItem;
}

function BackHair({ data }: Props) {
  const { backHair } = data;

  return (
    <HairMap className="body">
      <img className="hair-back" src={backHair} alt="" />
    </HairMap>
  );
}

export default BackHair;
